<template>
  <div :class="['asc-page-loading-indicator', loading ? 'loading' : '']">
    <template v-if="loading">
      <v-progress-linear
        bottom
        indeterminate
        :color="getColor"
        :height="4"
      ></v-progress-linear>
    </template>
    <slot></slot>
  </div>
</template>

<script>
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscPageLoadingIndicator',

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getColor() {
      return variables.accent500
    },
  },
}
</script>

<style lang="scss">
.asc-page-loading-indicator {
  .v-progress-linear {
    margin: 0;
  }
}
</style>
